var exports = {
  "k": "xfd349460--4cf6ff--container",
  "K": "xfd349460--4cf6ff--icon",
};

module.exports = exports;
